import React from 'react'
import Root from './Root'
export default ()=>(
    <Root />
)


// WEBPACK FOOTER //
// ./src/components/yields/index.js